import { Injectable } from '@angular/core';
import { ExternalUser } from '../models/auth.models';

const ACCESS_KEY = 'manarah-studio-access';
const REFRESH_KEY = 'manarah-studio-refresh';
const USER_KEY = 'manarah-studio-user';
const ACCESS_EXP_KEY = 'manarah-studio-access-expires';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  setTokens(accessToken: string, refreshToken: string, accessExpiresAt: string, user: ExternalUser): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
    localStorage.setItem(ACCESS_EXP_KEY, accessExpiresAt);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  setAccessToken(accessToken: string, accessExpiresAt: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(ACCESS_EXP_KEY, accessExpiresAt);
  }

  setRefreshToken(refreshToken: string): void {
    localStorage.setItem(REFRESH_KEY, refreshToken);
  }

  getAccessToken(): string | null { return localStorage.getItem(ACCESS_KEY); }
  getRefreshToken(): string | null { return localStorage.getItem(REFRESH_KEY); }

  getUser(): ExternalUser | null {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw) as ExternalUser; } catch { return null; }
  }

  setUser(user: ExternalUser): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  isAccessExpired(): boolean {
    const v = localStorage.getItem(ACCESS_EXP_KEY);
    if (!v) return true;
    return new Date(v).getTime() <= Date.now();
  }

  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(ACCESS_EXP_KEY);
  }
}
